import { Modal } from 'rsuite'
import { Button } from '../../atoms/button/button'
import React from 'react'

interface DeboardModalProps {
  modalOpen: boolean
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  modalTitle: string
  onDeboardClickHandler: () => void
  modalMessage: string
}

export const DeboardModal = ({
  modalOpen,
  setModalOpen,
  modalTitle,
  onDeboardClickHandler,
  modalMessage,
}: DeboardModalProps) => {
  return (
    <Modal
      open={modalOpen}
      keyboard={true}
      onClose={() => setModalOpen(false)}
      backdrop={true}
      size="xs"
    >
      <div className="modal-body-container">
        <Modal.Header>
          <Modal.Title>
            <p className="modal-title">{modalTitle}</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{modalMessage}</p>
        </Modal.Body>
      </div>
      <Modal.Footer>
        <div className="modal-btn-group">
          <Button
            removeDefaultCss
            ariaLabel="cancel button"
            handleClick={() => setModalOpen(false)}
            label={'Cancel'}
          />
          <Button
            removeDefaultCss
            ariaLabel="Confirm Button"
            handleClick={onDeboardClickHandler}
            label={'De-board'}
          />
        </div>
      </Modal.Footer>
    </Modal>
  )
}
